<template>
  <div class="spinner">
    <v-progress-circular :size="size" indeterminate dark></v-progress-circular>
  </div>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    size: {
      type: Number,
      default: 32,
    },
  },
};
</script>

<style scoped>
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
